import { render, staticRenderFns } from "./ParapharmacyProductSelector.vue?vue&type=template&id=159aa23e"
import script from "./ParapharmacyProductSelector.vue?vue&type=script&lang=js"
export * from "./ParapharmacyProductSelector.vue?vue&type=script&lang=js"
import style0 from "./ParapharmacyProductSelector.vue?vue&type=style&index=0&id=159aa23e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports